var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.794C12 11.2913 12.1975 11.7682 12.5492 12.1198C12.9008 12.4715 13.3777 12.669 13.875 12.669C14.3723 12.669 14.8492 12.4715 15.2008 12.1198C15.5525 11.7682 15.75 11.2913 15.75 10.794C15.75 10.2967 15.5525 9.81981 15.2008 9.46818C14.8492 9.11655 14.3723 8.91901 13.875 8.91901C13.3777 8.91901 12.9008 9.11655 12.5492 9.46818C12.1975 9.81981 12 10.2967 12 10.794Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.54401C19.5 9.04129 19.6975 9.5182 20.0492 9.86983C20.4008 10.2215 20.8777 10.419 21.375 10.419C21.8723 10.419 22.3492 10.2215 22.7008 9.86983C23.0525 9.5182 23.25 9.04129 23.25 8.54401C23.25 8.04672 23.0525 7.56981 22.7008 7.21818C22.3492 6.86655 21.8723 6.66901 21.375 6.66901C20.8777 6.66901 20.4008 6.86655 20.0492 7.21818C19.6975 7.56981 19.5 8.04672 19.5 8.54401Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.794V4.00001C15.75 3.68515 15.8491 3.37828 16.0333 3.12288C16.2174 2.86749 16.4773 2.67651 16.776 2.57701L21.276 1.32701C21.5015 1.25192 21.7415 1.23147 21.9764 1.26734C22.2114 1.30322 22.4344 1.39439 22.6272 1.53335C22.8199 1.67232 22.9769 1.85509 23.0852 2.06662C23.1935 2.27815 23.25 2.51238 23.25 2.75001V8.54401",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.75V22.25C17.25 22.6478 17.092 23.0294 16.8107 23.3107C16.5294 23.592 16.1478 23.75 15.75 23.75H2.25C1.85218 23.75 1.47064 23.592 1.18934 23.3107C0.908035 23.0294 0.75 22.6478 0.75 22.25V2.75C0.75 2.35218 0.908035 1.97064 1.18934 1.68934C1.47064 1.40804 1.85218 1.25 2.25 1.25H12.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.232 15.936C14.1473 16.9522 13.7685 17.9218 13.1418 18.7263C12.5151 19.5308 11.6677 20.1353 10.7031 20.4661C9.73845 20.7969 8.69837 20.8396 7.70988 20.589C6.72139 20.3384 5.82729 19.8053 5.13679 19.0549C4.44628 18.3045 3.98928 17.3692 3.82159 16.3633C3.6539 15.3574 3.7828 14.3245 4.19252 13.3906C4.60225 12.4568 5.27507 11.6625 6.12881 11.1048C6.98254 10.547 7.98022 10.25 8.99999 10.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5C7.5 15.8978 7.65804 16.2794 7.93934 16.5607C8.22064 16.842 8.60218 17 9 17C9.39782 17 9.77936 16.842 10.0607 16.5607C10.342 16.2794 10.5 15.8978 10.5 15.5C10.5 15.1022 10.342 14.7206 10.0607 14.4393C9.77936 14.158 9.39782 14 9 14C8.60218 14 8.22064 14.158 7.93934 14.4393C7.65804 14.7206 7.5 15.1022 7.5 15.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.75C7.5 6.14782 7.65804 6.52936 7.93934 6.81066C8.22064 7.09196 8.60218 7.25 9 7.25C9.39782 7.25 9.77936 7.09196 10.0607 6.81066C10.342 6.52936 10.5 6.14782 10.5 5.75C10.5 5.35218 10.342 4.97064 10.0607 4.68934C9.77936 4.40804 9.39782 4.25 9 4.25C8.60218 4.25 8.22064 4.40804 7.93934 4.68934C7.65804 4.97064 7.5 5.35218 7.5 5.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.2b0b965b.svg";
export { ForwardRef as ReactComponent };